import React from 'react';
import styled from 'styled-components';
import Select from '../../../../components/Select/SelectFilter';
import RadioButtons from '../../../../components/RadioButtons';

const NegoceFiltersContainer = styled.div`
  .negoceFiltersContainer {
    display: grid;
    grid-template-columns: 1fr 1fr max-content 1fr;
    grid-column-gap: 25px;
    grid-row-gap: ${(props) => (props.negociantsFilter ? '25px' : '0')};

    .wineFilter {
      grid-column: 1;
    }

    .salesFilter {
      grid-column: 2;
    }

    .separator {
      grid-area: 3 / 1 / 3 / 2;
      grid-row-start: 1;
      grid-column-start: 3;
      grid-row-end: 3;
      grid-column-end: 3;
      width: 5px;
      height: 100%;
      background-color: #eff0f2;
      display: ${(props) => (props.wineFilter ? 'block' : 'none')};
    }

    .campaignFilter {
      grid-column: ${(props) => (props.wineFilter ? '4' : '1')};
    }

    .negociantsFilter {
      grid-column: ${(props) => (props.salesFilter ? '1' : '4')};
    }
  }
`;

const NegoceFilters = ({
  campaignFilter,
  salesFilter,
  wineFilter,
  negociantsFilter
}) => (
  <NegoceFiltersContainer
    negociantsFilter={negociantsFilter}
    wineFilter={wineFilter}
    salesFilter={salesFilter}
  >
    <div className="negoceFiltersContainer">
      {wineFilter && (
        <div className="wineFilter">
          <Select {...wineFilter} />
        </div>
      )}
      {salesFilter && (
        <div className="salesFilter">
          <RadioButtons {...salesFilter} />
        </div>
      )}
      <div className="separator" />
      {campaignFilter && (
        <div className="campaignFilter">
          <Select {...campaignFilter} />
        </div>
      )}
      {negociantsFilter && (
        <div className="negociantsFilter">
          <Select {...negociantsFilter} />
        </div>
      )}
    </div>
  </NegoceFiltersContainer>
);
export default NegoceFilters;
